module.exports = __webpack_public_path__ + "static/media/track.e3ee105e.png";